import React, { Component } from 'react';
import Select from 'react-select';
import Switch from "react-switch";

import { Row, Col } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultCarreras} from '../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../funciones/CalifDirFunction';
import { ConsultaProfes, ConsultaProfesSem } from "../../funciones/CalifDirFunction";

import ModalForm from "../../components/Modal/ModalForm";

import OrdenCi from "./CalificacionesContent/OrdenCi";
import OrdenApe from "./CalificacionesContent/OrdenApe";
import EditCalif from "./CalificacionesContent/EditCalif";

let seccion = "";

class Calificaciones extends Component {
    state = {
        ci: true,
        ape: false,
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        prof:  { text:"", status: "" },
        profComponent:  [],
        profComponentSem: [],
        preloaderProf: {
            icon: "",
            text: "Ingresa primero el nombre o la cédula del profesor"
        },

        preloaderSem: {
            icon: "",
            text: "Ingresa primero la carrera y el semestre"
        },
        openW: false,
        literales:[]
    }

    constructor (props) {
        super (props);

        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })
    }

    enterTab = () => (e) => {
        if (e.which === 13){
            if (this.state.prof.text === "") return null;
            this.setState({
                preloaderProf: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando"
                }
            }, () => {
                ConsultaProfes (this.state.prof.text, (resp) => {
                    if(resp[0].length === 0) {
                        this.setState({
                            profComponent: resp[0],
                            literales: resp[1],
                            preloaderProf: {
                                icon: "",
                                text: "La búsqueda no obtuvo coincidencias"
                            }
                        })
                    }else{
                        this.setState({
                            profComponent: resp[0],
                            literales: resp[1],
                        })
                    }
                })
            })
        }
    }

    cerrarModal = () => {
        this.setState ({
            openW: false,
        })
    }

    contenidoModal = () => (<EditCalif seccion= {seccion} cerrar = {()=> this.cerrarModal()} literales = {this.state.literales}/>)

    showModal = () => {
        const { openW } = this.state;
        return (
            <ModalForm
                isopen =  {openW}
                titulo = {<div>Editar Calificaciones</div>}
                contenido = {this.contenidoModal()}
                cerrar = {this.cerrarModal}
            />
        );
    }

    openWNotas = (sec, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo) => {
        seccion = {sec, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo};
        this.setState({openW: true})
    }

    cambiaList = () => {
        /* seccion = ""; */
        this.setState({
            ci: !this.state.ci,
            ape: !this.state.ape,
            profComponent:  [],
        }, () => {
            if (this.state.ci === true){
                this.setState({
                    valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
                    valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
                    semestres: []
                })
            }else{
                this.setState({
                    prof:  { text: "", status: "" },
                    profComponent:  [],
                    preloaderProf: { icon: "", text: "Ingresa primero el nombre o la cédula del profesor" },
                })
            }
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            preloaderSem: {
                icon: "fa fa-spinner fa-spin",
                text: "Buscando"
            }
        }, () => {
            ConsultaProfesSem (valorSemestre.value, (resp) => {
                if(resp[0].length === 0) {
                    this.setState({
                        profComponentSem: resp[0],
                        literales: resp[1],
                        preloaderSem: {
                            icon: "",
                            text: "La búsqueda no obtuvo coincidencias"
                        }
                    })
                }else{
                    this.setState({
                        profComponentSem: resp[0],
                        literales: resp[1],
                    })
                }
            })
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            }
        });
    };

    filtro = () => {
        if (this.state.ci === true){
            let { prof } = this.state;
            return (
                <div>
                    <input type="text" value={prof.text} onChange={this.cambiaValor("prof")} onKeyPress={this.enterTab()} className="form-control" placeholder="Ingresa la C.I. o Nombre del profesor"/>
                    <span className="text-muted" style={{fontSize: 10}}>Ingresa el profesor y presiona Enter</span>
                </div>
            )
        }else{
            let { valorCarrera, carreras, valorSemestre, semestres } = this.state;
            return(
                <Row>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={valorCarrera}
                            onChange={this.valorSelectCarrera}
                            options={carreras}
                        />
                        <span className="text-muted" style={{fontSize: 10}}>Carreras</span>
                    </Col>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={valorSemestre}
                            onChange={this.valorSelectSemestre}
                            options={semestres}
                        />
                        <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                    </Col>
                </Row>
            )
        }
    }

    componente = () => {
        let {  ci, profComponent, profComponentSem, preloaderProf, preloaderSem } = this.state;

        if (ci === true){
            return (<OrdenCi prof ={profComponent} preloader={preloaderProf}
            funcion = {(seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo) => {this.openWNotas(seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo)}}/>)
        }else{
            return (<OrdenApe prof ={profComponentSem} preloader={preloaderSem}
            funcion = {(seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo) => {this.openWNotas(seccion, codigo, materia, nombre, carrera, semestre, cualitativo, cuantitativo)}}/>)
        }
    }

    contenido = () => {
        let { ci, ape } = this.state;
        return (
            <React.Fragment>
                <div className="custom-alert-info" style={{padding: 5}}>
                    <Row>
                        <Col md={3}>
                            <div><strong>Buscar por:</strong></div>
                            <Row>
                                <Col md={6} title="Buscar Materias por Profesor">
                                    <Switch height={12} width={24} onChange={this.cambiaList} checked={ci} />
                                    <div style={{fontSize: 11}}>Profesor</div>
                                </Col>
                                <Col md={6} title="Buscar Materias por Carreras">
                                    <Switch height={12} width={24} onChange={this.cambiaList} checked={ape} />
                                    <div style={{fontSize: 11}}>Carrera</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={9}>
                            {this.filtro()}
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-20">
                    <Col md={12}>
                        {this.componente()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    cambia = () => {

    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    En esta sección puedes cargar las calificaciones de las diferentes secciones en cualquier corte. Para esto debes hacer lo siguiente:
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    Selecciona una opción de búsqueda entre las disponibles:
                </Col>
                <Col md={3} className="custom-mt-10">
                    <Switch height={12} width={24} onChange={this.cambia} checked={true} />
                    <div style={{fontSize: 11}}>Profesor</div>
                </Col>
                <Col md={9} className="custom-mt-10" align="justify">
                    Ingresa la Cédula de Identidad o parte de ella para buscar las secciones del profesor. 
                    También puedes ingresar un nombre o apellido en la consulta.
                </Col>
                <Col md={3} className="custom-mt-10">
                    <Switch height={12} width={24} onChange={this.cambia} checked={false} />
                    <div style={{fontSize: 11}}>Carrera</div>
                </Col>
                <Col md={9} className="custom-mt-10" align="justify">
                    <div>Debes seleccionar primero una carrera.</div>
                    <div>Esto te permitirá seleccionar un semestre de dicha carrera</div>
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    Una vez seleccionada la búsqueda aparecerán los resultados con las Secciones Disponibles que puedes acceder mediante el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1,}}><i className="fa fa-edit"></i></button> el cual te abrirá una ventana con las opciones de la Sección.
                </Col>
            </Row>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Carga de Calificaciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModal()}
            </div>
        );
    }
}
 
export default Calificaciones;


// WEBPACK FOOTER //
// ./src/views/Academicos/Calificaciones.jsx